import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { User } from '../../core/model/user.model';

@Injectable({
    providedIn: 'root'
})
export class UserService {

    constructor(private httpClient: HttpClient) {
    }

    searchUser(searchPattern): Observable<User> {

        return this.httpClient
            .get(`/servlets/accounts/users/search/${searchPattern}/`, {observe: 'body'})
            .pipe(
                map((response: any) => response.users)
            );
    }

    getSelectedUserById(userId): Observable<User> {
        return this.httpClient
            .get(`/servlets/accounts/users/${userId}/`, {observe: 'body'})
            .pipe(
                map((response: any) => response.user)
            );
    }

    getUserCustomFields(userId): Observable<any> {
        return this.httpClient
            .get(`/servlets/accounts/users/${userId}/communication/`, {observe: 'body'})
            .pipe(
                map((response: any) => response.account.userCustomFields)
            );
    }

}
